import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import { Button } from '@headlessui/react';
import { cn } from '@/app/_lib/utils';
type SubscriptionTabsProps = {
  tabs: Subscription[];
  activeTab: Subscription;
  setActiveTab: React.Dispatch<React.SetStateAction<Subscription>>;
  goalPage?: boolean;
  className?: string;
};
export function SubscriptionTabs(t0) {
  const $ = _c(13);
  const {
    tabs,
    activeTab,
    setActiveTab,
    goalPage: t1,
    className
  } = t0;
  const goalPage = t1 === undefined ? false : t1;
  const t2 = goalPage ? "border-borderSupport bg-borderPrimary" : "border-slate-200 bg-slate-100";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("flex touch-pan-x gap-1 overflow-x-auto rounded-lg border p-1", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeTab || $[4] !== setActiveTab || $[5] !== tabs) {
    let t5;
    if ($[7] !== activeTab || $[8] !== setActiveTab) {
      t5 = tab => <Button key={tab} className={cn("group rounded-xl px-4 py-1.5 hover:bg-backgroundHoverOverlay", activeTab === tab && "bg-white hover:bg-white")} onClick={() => setActiveTab(tab)}><p className={cn("text-nowrap text-contentSecondary", activeTab === tab && "font-medium text-slate-900")}>{tab}</p></Button>;
      $[7] = activeTab;
      $[8] = setActiveTab;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = tabs.map(t5);
    $[3] = activeTab;
    $[4] = setActiveTab;
    $[5] = tabs;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}